import PostGrid from '../../components/Grid/PostGrid';
import CountryFacts from 'components/Destinations/CountryFacts';
import { imageProxy } from 'tf-post-parser';
import Image from 'components/Image';
import { makeStyles } from 'tss-react/mui';
import Head from '../Header/Head';
import emojiFlags from 'emoji-flags';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles()(theme => ({
  root: {
    background: theme.palette.background.default,
  },
}));

export default function DestinationTravelGuide({
  locationDetails,
  query,
  noEdit,
  itineraries,
  noIndex,
  breadcrumbs,
}) {
  const { classes } = useStyles();

  const generatedOgImage = `https://tfog.b-cdn.net/api/travelGuide?title=${encodeURIComponent(
    locationDetails.title,
  )}&image=${imageProxy(locationDetails.image, 1920, 1200)}`;

  let acceptedAnswerText = '<ul>';
  if (locationDetails.travelTimes && locationDetails.travelTimes.length > 0)
    locationDetails.travelTimes.forEach(({ monthRange, seasonDescription }) => {
      acceptedAnswerText += `<li><strong>${monthRange}</strong> ${seasonDescription}</li>`;
    });
  acceptedAnswerText += '</ul>';
  const whenToGoFaqItem = {
    questionName: 'When to go?',
    acceptedAnswerText,
  };

  return (
    <>
      <Head
        shorttitle={`${
          emojiFlags.countryCode(locationDetails.countryCode.toUpperCase())
            .emoji
        } ${locationDetails.title} Travel Guide (${new Date().getFullYear()})`}
        description={`The ultimate travel guide to ${locationDetails.title}: Your all-in-one travel resource for insider tips, itineraries, must-sees and hidden gems in ${locationDetails.title}.`}
        faq={[whenToGoFaqItem, ...locationDetails.faq]}
        image={generatedOgImage}
        includeMapbox
        noIndex={noIndex}
        breadcrumbs={breadcrumbs}
        // breadcrumbs={breadcrumbs} // TODO: Add region to breadcrumbs, create region pages/travel guides
      />

      <div className="tw-fixed tw-h-screen tw-w-full">
        <div className="tw-h-screen tw-relative -tw-mt-[65px]">
          <Image
            alt={locationDetails.title}
            src={imageProxy(locationDetails.image, 1920, 1200)}
            layout="fill"
            className="tw-brightness-50 tw-object-cover tw-object-center"
            blurDataURL={locationDetails.blur}
            placeholder={locationDetails.blur ? 'blur' : undefined}
          />
        </div>
      </div>
      <div className="tw-z-10 tw-relative">
        {locationDetails.currencies && locationDetails.currencies.length > 0 && (
          <div className="tw-text-gray-200">
            <CountryFacts
              locationDetails={locationDetails}
              noEdit={noEdit}
              itineraries={itineraries}
            />
          </div>
        )}
        <div className={classes.root}>
          <Typography
            gutterBottom
            variant="h4"
            component="h2"
            className="pt-4 text-center tw-font-semibold"
            color="textPrimary"
          >
            {locationDetails.title} Travel Blogs
          </Typography>
          <div className="container pb-4 containerInvisibleOnMobile">
            <PostGrid
              active="destination"
              query={query}
              grid={{ lg: 4, md: 4, sm: 6, xs: 12 }}
              cardHeight={200}
              poststyle="grid"
            />
          </div>
        </div>
      </div>
    </>
  );
}
